
import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { globalHistory } from "@reach/router"

function SEO(props)
{
	const { site } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						local
						title
						title_fc
						description
						site_name
						site_name_fc
						site_url
						image
						twitter {
							id
							card
						}
					}
				}
			}
		`
	)

	const { pathname } = globalHistory.location
	const isMember = pathname.match(/member/g)
	const faviconLink = `/${isMember ? "favicon_fc.ico" : "favicon_front.ico"}`
	const iconLink = `/${isMember ? "icon_fc.png" : "icon_front.png"}`

	const info = Object.assign({}, site.siteMetadata, props)
	info.title = isMember ? info.title_fc : info.title
	// info.description = replaceTag(info.description)//
	if (info.slug) {
		info.url = `${info.site_url}${info.slug}`
	} else {
		info.url = info.site_url
	}
	if (!props.image) {
		info.image = `${info.site_url}/${!isMember ? "ogp.png" : "ogp_fc.png"}` 
	} else {
		info.image = `${info.site_url}${info.image}` 
	}
	if (info.subtitle) {
		info.title = `${info.subtitle} | ${info.title}`
	}

	return (
		<>
				<title>{info.title}</title>
				<meta name="viewport" content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover"/>
				<meta name="apple-mobile-web-app-capable" content="yes"/>{/*ホーム画面から起動時にアプリのようにする*/}
				<meta name="apple-mobile-web-app-status-bar-style" content="black-translucent"/>{/*ノッチまわりの表示*/}

				<meta httpEquiv="X-UA-Compatible" content="IE=edge"/>

				<meta name="description" content={info.description} />
				<meta name="image" content={info.image} />
				<meta property="og:locale" content={info.local} />
				<meta property="og:type" content={ info.isArticle ? 'article' : 'website'} />
				<meta property="og:url" content={info.url} />
				<meta property="og:title" content={info.title} />
				<meta property="og:site_name" content={info.site_name} />
				<meta property="og:description" content={info.description} />
				<meta property="og:image" content={info.image} />

				{ info.twitter.id && (
					<meta name="twitter:creator" content={info.twitter} />
				)}
				<meta name="twitter:title" content={info.title} />
				<meta name="twitter:description" content={info.desc} />
				<meta name="twitter:image" content={info.image} />
				<meta name="twitter:card" content={info.twitter.card} />
				{ info.robot && (
					<meta name="robots" content="noindex"/>
				)}
				
				<link rel="icon" href={faviconLink} />
				<link rel="apple-touch-icon" href={iconLink} />
		</>
	)
}

export default SEO
